import React from 'react';
import { Coffee, Crown } from 'lucide-react';

export default function UserBadge({ user, tier, size = 16, style = {} }) {
    // Determine the tier either from the user object or direct prop
    const userTier = tier || user?.subscriptionTier;

    if (!userTier) return null;

    if (userTier === 'subscriber') {
        return React.createElement('span', {
            title: "Supporter 🥤",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                marginLeft: '6px',
                verticalAlign: 'middle',
                cursor: 'help', // added cursor to indicate hoverable
                ...style
            }
        }, React.createElement(Coffee, {
            size: size,
            strokeWidth: 2.5,
            color: 'var(--secondary)' // Pink for Supporter
        }));
    }

    if (userTier === 'super_subscriber' || userTier === 'superSubscriber') {
        return React.createElement('span', {
            title: "Super Fan 👑",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                marginLeft: '6px',
                verticalAlign: 'middle',
                cursor: 'help',
                ...style
            }
        }, React.createElement(Crown, {
            size: size,
            strokeWidth: 2.5,
            color: 'var(--primary)',
            fill: 'rgba(139, 92, 246, 0.2)'
        }));
    }

    if (userTier === 'mega_fan') {
        return React.createElement('span', {
            title: "Mega Fan 🦄",
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                marginLeft: '6px',
                verticalAlign: 'middle',
                cursor: 'help',
                ...style
            }
        }, React.createElement(Crown, {
            size: size,
            strokeWidth: 2.5,
            color: '#FFD700', // Gold
            fill: 'rgba(255, 215, 0, 0.2)'
        }));
    }

    return null;
}
